import { humanBytes } from '../lib/api'

interface Props {
  label: string
  used?: number
  total?: number
  percent?: number // если задан вручную
  tone?: 'green' | 'yellow' | 'red'
}

export function UsageBar({ label, used = 0, total = 0, percent, tone }: Props) {
  const p = percent !== undefined
    ? Math.max(0, Math.min(100, percent))
    : total > 0 ? Math.max(0, Math.min(100, (used / total) * 100)) : 0

  const autoTone: 'green' | 'yellow' | 'red' =
    p > 85 ? 'red' : p > 65 ? 'yellow' : 'green'
  const t = tone || autoTone
  const barColor = { green: 'bg-green-500', yellow: 'bg-yellow-500', red: 'bg-red-500' }[t]

  return (
    <div className="min-w-[140px]">
      <div className="flex items-center justify-between text-[11px] text-neutral-500 mb-1">
        <span>{label}</span>
        <span className="tabular-nums text-neutral-700 font-medium">
          {percent !== undefined
            ? `${p.toFixed(1)}%`
            : `${humanBytes(used)} / ${humanBytes(total)}`}
        </span>
      </div>
      <div className="h-1.5 bg-neutral-200 rounded-full overflow-hidden">
        <div className={`h-full ${barColor} transition-all`} style={{ width: `${p}%` }} />
      </div>
    </div>
  )
}
